import React, { useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectCoverflow } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/effect-coverflow';

function ImageIntroduction() {
    const swiperRef = useRef(null);

    // 图片数据
    const images = [
        {
            src: require("./img/golden-shouldered_parrot_with_tree.png"),
            alt: "Golden Shouldered Parrot with tree",
            label: "Golden Shouldered Parrot",
            hasLabel: true
        },
        {
            src: require("./img/golden-shouldered_parrot1.png"),
            alt: "Golden Shouldered Parrot 1",
            label: "Golden Shouldered Parrot",
            hasLabel: true
        },
        {
            src: require("./img/McNemo_fish_with_hand.png"),
            alt: "McNemo Fish with hand",
            label: "McNemo Fish",
            hasLabel: true
        },
        {
            src: require("./img/Night-Parrot1.png"),
            alt: "Night Parrot 1",
            label: "Night Parrot",
            hasLabel: true
        },
        {
            src: require("./img/McNemo_fish_with_coral.png"),
            alt: "McNemo Fish with coral",
            label: "McNemo Fish",
            hasLabel: true
        }
    ];

    // 渲染单个图片项
    const renderImageItem = (image, index) => (
        <div className="swiper-image-item">
            <div className="swiper-image-card">
                {image.hasLabel ? (
                    <div className="swiper-image-wrapper">
                        <img 
                            className="swiper-image" 
                            src={image.src} 
                            alt={image.alt}
                        />
                        <div className="swiper-image-label">{image.label}</div>
                    </div>
                ) : (
                    <img 
                        className="swiper-image" 
                        src={image.src} 
                        alt={image.alt}
                    />
                )}
            </div>
        </div>
    );

    return (
        <section className="projects-section">
            <div className="projects-container">
                <div className="projects-header">
                    <h2 className="projects-title">Previous Partnership Projects</h2>
                    <p className="projects-subtitle">Exploring Past Projects</p>
                </div>
                <div className="swiper-container-wrapper">
                    <Swiper
                        ref={swiperRef}
                        modules={[Autoplay]}
                        spaceBetween={20}
                        slidesPerView="auto"
                        loop={true}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        }}
                        speed={800}
                        breakpoints={{
                            320: {
                                slidesPerView: 1.2,
                                spaceBetween: 15,
                            },
                            768: {
                                slidesPerView: 2.5,
                                spaceBetween: 18,
                            },
                            1024: {
                                slidesPerView: 3.5,
                                spaceBetween: 20,
                            },
                            1280: {
                                slidesPerView: 4,
                                spaceBetween: 20,
                            },
                        }}
                        className="projects-swiper"
                    >
                        {images.map((image, index) => (
                            <SwiperSlide key={index} className="swiper-slide-custom">
                                {renderImageItem(image, index)}
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    )
}

export default ImageIntroduction
